import React, { useEffect, useState } from 'react';
import { Grid } from '~/components';
import { MdFilterList, MdEdit } from 'react-icons/md';
import { auth } from '~/api';
import { getFirms } from '~/api/lawfirm';
import { DropDown } from '~/components';
import { Link } from 'react-router-dom';
import { auth as authUtil } from '~/util';
import { useAuth } from '~/hooks';
import FilterUsers from './FilterUsers';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import { FaUserPlus } from 'react-icons/fa';

const headerClassName = 'bg-gray-50 p-2 border-b text-left';
const props = {
    className: 'p-2 pr-4 border-b'
};

const ShowUsers = () => {
    const { user } = useAuth();

    const columns = [
        { 
            title: 'Name', 
            field: 'name',
            headerClassName,
            props
        },
        { 
            title: 'Firm Name', 
            field: 'firmname',
            headerClassName,
            props
        },
        {
            title: 'Title',
            field: 'title',
            headerClassName,
            props
        },
        {
            title: 'User role',
            field: 'role',
            headerClassName,
            props
        },
        {
            title: 'Action',
            canSort: false,
            cell: ({ data }) => {
                return (
                    <>
                        <DropDown
                            wrapperClass="rounded-md border bg-white z-20 filter drop-shadow-xl right-1/4 top-full mt-1"
                            iconClass="text-white ml-2"
                            iconSize='1.25em'
                            buttonClass="py-1 pl-3 pr-2 bg-blue-50 text-white text-sm focus:outline-none rounded-full flex items-center justify-center h-7 my-2"
                            text='Actions'>
                            <section className="flex flex-col items-stretch w-48 text-gray-80">
                                <p className="font-semibold text-sm p-4 py-2">Action</p>
                                <Link to={`/edituser/${data.userId}`} className="py-2 px-4 hover:bg-blue-10 flex items-center">
                                    <MdEdit />
                                    <span className="ml-2">Edit User</span>
                                </Link>
                            </section>
                        </DropDown>
                    </>
                );
            },
            headerClassName,
            props
        }
    ];

    const [rows, setRows] = useState([]);
    const [isFilterModalOpen, setFilterModalOpen] = useState(false);
    const [isLoading, setLoading] = useState(true);
    const [userList, setUserList] = useState([]);
    
    const compare = (a, b) =>{
        const item01 = a.name.toUpperCase();
        const item02 = b.name.toUpperCase();
        
        let comparison = 0;
        if (item01 > item02) {
            comparison = 1;
        } else if (item01 < item02) {
            comparison = -1;
        }
        return comparison;
    };

    useEffect(() => {
        let mounted = true;

        const fetchData = async() => {
            if(mounted) {
                const [firmsData, usersData] = await Promise.all([getFirms(),auth.getAllUsers()]);

                let rowData = usersData.map((u) => {
                    let name = `${u.firstName}  ${u.lastName}`;
                    let firmData = u.firmId && firmsData.find( ({ Id }) => Id == u.firmId.trim() );
                    let firmName = firmData !== undefined && firmData !== null ? firmData['Name'] : '';
                    let preferences = JSON.parse(u.preferences);
                    let title = preferences?.title;
                    let role = u.roleName;
                    let userId = u.id !== undefined ? u.id : '';
    
                    return {
                        name,
                        firmname: firmName,
                        title: title == undefined ? '' : title,
                        role,
                        roleId: u.roleId,
                        userId,
                        firmId: u.firmId,
                        activated: u.activated
                    };
                });

                /*Filter: a Law Firm admin can view Tryon Express users within their law firm only*/
                if(authUtil.isLawFirm(user.roleId)){
                    rowData = rowData.filter((u) =>  u.firmId == user.firmId);
                }

                const newUsers = rowData.filter(u => u.activated === null);
                const existingUsers =  rowData.filter(u => u.activated !== null);
                const finalUserList = newUsers.concat(existingUsers.sort(compare));

                setRows(finalUserList);
                setUserList(finalUserList);
                setLoading(false);
            }
            
        };

        fetchData();

        return () => mounted = false;
    }, []); 

    const updateFilteredData = async (filtered=[]) => {
        setRows(filtered);
    };

    const cancelFilters = () => {
        setFilterModalOpen(false);
    }; 

    const openFiltersModal = () => {
        setFilterModalOpen(true);
    }; 

    return (
        <React.Fragment>
            {isLoading ?
                (<AiOutlineLoading3Quarters className="w-full animate-spin text-blue-30 font-bold" size="4rem" />)            
                :
                
                <div>
                    <div className="flex flex-row justify-between content-center mb-4 mt-8">
                        <button 
                            className="h-9 py-2 px-4 flex text-blue-dark text-sm font-semibold bg-gray-50 focus:outline-none items-center justify-center rounded-full"
                            onClick={() => openFiltersModal()}>
                            <MdFilterList size='1.125em' className='mr-1'/>
                            <span className="ml-2">Filters</span>
                        </button>
                        <Link to="/adduser" className="h-9 py-2 px-4 bg-blue-50 text-white text-sm rounded-full flex items-center justify-center">
                            <FaUserPlus />
                            <span className="ml-2">Add User</span>
                        </Link>
                    </div>
                    
                    <FilterUsers
                        isModalOpen={isFilterModalOpen}
                        onCancel={cancelFilters}
                        headerTxt={'Filters'}
                        applyFilter={updateFilteredData}
                        data = {userList}
                    />
                    {rows.length > 0  ?
                        <Grid 
                            className='w-full text-sm'
                            rowSelect
                            data={rows}
                            columns={columns}
                            usePagination={true}
                        /> 
                        :
                        'No Results Found.'
                    }
                </div>
            }
            {                   
            }
        </React.Fragment>
    );
};




export default ShowUsers;
